import API from "@/assets/js/api.js"
import { ajax } from "@/assets/js/ajax.js"
const state = {
  apikey: []
}
const mutations = {
  SET_KEY: (state, data) => {
    state.apikey = data
  },
}
const actions = {
  async getKey({ commit }, data) {
    let getCodeList = (v) => {     //公共 调用
      return new Promise((resolve, reject) => {
        ajax({
          url: v.url,      //url 
          type: "get",
          success: (e) => {
            resolve({
              list: e.list,            //统一返回为多级数组
              key: v.out        // 设置key值
            })
          }
        })
      })
    }
    let getAll = async () => {        //循环抛请求 
      let result = await Promise.all(API.map(ele => { return getCodeList(ele) }))
      return result;
    }
    getAll().then(result => {     //初始状态进行请求
      let newObj = {}             //设置想要的存储对象格式  
      result.map(ele => {
        newObj[ele.key] = ele.list
      })
      commit('SET_KEY', newObj)
      localStorage.setItem('car', JSON.stringify(newObj))
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
